module.exports = __webpack_public_path__ + "img/type_stahl.71707a7f.svg";